export const consentTour = {
    module: 'consent',
    title: 'Consent Tour',
    title_vi: 'Tour Đồng thuận',
    description: 'As the Enterprise DPO (P-VN-01), manage the consent policy lifecycle: define collection purposes, enforce PDPL withdrawal rights, and integrate with your Consent Management Platform.',
    description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Enterprise DPO (P-VN-01), manage the consent policy lifecycle: define collection purposes, enforce PDPL withdrawal rights, and integrate with your Consent Management Platform.',",
    estimated_duration_seconds: 48,
    steps: [
        {
            step_id: 'open_consent',
            navigate_to: '/admin/consent/policies',
            target: '.dm-page',
            title: 'Consent Policy Lifecycle',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Consent Policy Lifecycle',
            description: 'As the DPO, you manage consent policies and purposes here. Unlike Consent Properties (which configures CMP deployment settings), this module defines WHAT consent you collect and WHY under PDPL legal bases.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the DPO, you manage consent policies and purposes here. Unlike Consent Properties (which configures CMP deployment settings), this module defines WHAT consent you collect and WHY under PDPL legal bases.',
            position: 'bottom',
        },
        {
            step_id: 'policies_list',
            target: '.dm-table',
            title: 'Consent Policies',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Consent Policies',
            description: 'All active and draft consent policies with version history. PDPL requires clear, purpose-specific consent that data subjects can withdraw at any time.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: All active and draft consent policies with version history. PDPL requires clear, purpose-specific consent that data subjects can withdraw at any time.',
            position: 'bottom',
        },
        {
            step_id: 'create_policy',
            target: '.dm-header .btn-primary',
            title: 'Create a Policy',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Policy',
            description: 'Define a new consent policy with its scope, data categories, and PDPL legal basis. Each policy version is tracked for regulatory traceability.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define a new consent policy with its scope, data categories, and PDPL legal basis. Each policy version is tracked for regulatory traceability.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 100,
        },
        {
            step_id: 'fill_policy_name',
            target: '[data-testid="policy-name"]',
            title: 'Name the Policy',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Name the Policy',
            description: 'Use a descriptive name reflecting the processing purpose. PDPL requires consent to be purpose-specific, not bundled.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Use a descriptive name reflecting the processing purpose. PDPL requires consent to be purpose-specific, not bundled.',
            position: 'bottom',
            wait_for: '[data-testid="policy-name"]',
            action: {
                type: 'fill',
                target: '[data-testid="policy-name"]',
                value: '[TOUR] Marketing Email Consent',
            },
        },
        {
            step_id: 'fill_policy_description',
            target: '[data-testid="policy-description"]',
            title: 'Describe the Policy',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Describe the Policy',
            description: 'Clearly describe the data collected and its use. PDPL mandates that consent notices be transparent and understandable to Vietnamese data subjects.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Clearly describe the data collected and its use. PDPL mandates that consent notices be transparent and understandable to Vietnamese data subjects.',
            position: 'bottom',
            action: {
                type: 'fill',
                target: '[data-testid="policy-description"]',
                value: '[TOUR] Consent for collecting email addresses and preferences for marketing communications per GDPR Art. 6(1)(a).',
            },
        },
        {
            step_id: 'select_legal_basis',
            target: '[data-testid="legal-basis"]',
            title: 'Select Legal Basis',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select Legal Basis',
            description: 'Choose the PDPL legal basis. Sensitive personal data (health, biometrics, political opinions) requires explicit consent; other categories may use legitimate interest or contractual necessity.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Choose the PDPL legal basis. Sensitive personal data (health, biometrics, political opinions) requires explicit consent; other categories may use legitimate interest or contractual necessity.',
            position: 'bottom',
            action: { type: 'select', target: '[data-testid="legal-basis"]', value: 'consent' },
        },
        {
            step_id: 'submit_policy',
            target: '.dm-form-actions button[type="submit"]',
            title: 'Save the Policy',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the Policy',
            description: 'Save the policy to the registry. It can then be linked to collection purposes and deployed to your CMP via the Consent Properties module.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the policy to the registry. It can then be linked to collection purposes and deployed to your CMP via the Consent Properties module.',
            position: 'top',
            duration_ms: 100,
        },
        {
            step_id: 'navigate_purposes',
            navigate_to: '/admin/consent/purposes',
            target: '.dm-page',
            title: 'Collection Purposes',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Collection Purposes',
            description: 'Define the specific processing purposes data subjects consent to. Each purpose maps to a granular consent option, fulfilling PDPL purpose limitation requirements.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define the specific processing purposes data subjects consent to. Each purpose maps to a granular consent option, fulfilling PDPL purpose limitation requirements.',
            position: 'bottom',
        },
        {
            step_id: 'purposes_table',
            target: '.dm-table',
            title: 'Purpose Registry',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Purpose Registry',
            description: 'Each purpose links to its retention period and ROPA processing activities, creating a traceable chain from consent collection to data lifecycle management.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each purpose links to its retention period and ROPA processing activities, creating a traceable chain from consent collection to data lifecycle management.',
            position: 'bottom',
        },
        {
            step_id: 'create_purpose',
            target: '.dm-header button',
            title: 'Create a Purpose',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Purpose',
            description: 'Define a new collection purpose. PDPL requires each purpose to be specific, explicit, and legitimate at the time consent is obtained.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define a new collection purpose. PDPL requires each purpose to be specific, explicit, and legitimate at the time consent is obtained.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header button' },
            duration_ms: 100,
        },
        {
            step_id: 'fill_purpose_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Fill In Purpose Details',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Fill In Purpose Details',
            description: 'Enter the purpose name, legal basis, and category. Linking to ROPA activities ensures end-to-end traceability from consent to data processing under PDPL.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter the purpose name, legal basis, and category. Linking to ROPA activities ensures end-to-end traceability from consent to data processing under PDPL.',
            position: 'bottom',
        },
        {
            step_id: 'submit_purpose',
            target: '.dm-form-actions button[type="submit"]',
            title: 'Save the Purpose',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the Purpose',
            description: 'Save the purpose to the registry. It becomes available for linking to consent policies and for deployment to your CMP through Consent Properties.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the purpose to the registry. It becomes available for linking to consent policies and for deployment to your CMP through Consent Properties.',
            position: 'top',
        },
        {
            step_id: 'navigate_cmp',
            navigate_to: '/admin/consent/cmp-integration',
            target: '.dm-page',
            title: 'CMP Integration',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: CMP Integration',
            wait_for: '.dm-page',
            description: 'Connect to your Consent Management Platform for bidirectional consent record sync. This ensures withdrawal requests are propagated in real time, fulfilling PDPL withdrawal rights.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Connect to your Consent Management Platform for bidirectional consent record sync. This ensures withdrawal requests are propagated in real time, fulfilling PDPL withdrawal rights.',
            position: 'bottom',
        },
        {
            step_id: 'webhooks',
            navigate_to: '/admin/consent/cmp-integration/webhook',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Webhook Configuration',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Webhook Configuration',
            description: 'Configure webhooks to propagate consent events (grant, withdrawal, update) to downstream systems. Ensures processing stops promptly when a data subject withdraws consent under PDPL.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Configure webhooks to propagate consent events (grant, withdrawal, update) to downstream systems. Ensures processing stops promptly when a data subject withdraws consent under PDPL.',
            position: 'bottom',
        },
        {
            step_id: 'consent_complete',
            target: '.dm-page',
            title: 'Consent Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Consent Tour Complete',
            description: 'You can now manage the full PDPL consent lifecycle: purpose-specific policies, granular collection purposes, CMP integration, and real-time withdrawal propagation with audit-grade evidence trails.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now manage the full PDPL consent lifecycle: purpose-specific policies, granular collection purposes, CMP integration, and real-time withdrawal propagation with audit-grade evidence trails.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=consent.js.map